// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"b6efb6f0","180":"d29653fd","208":"112bdc17","631":"cb98f83b","774":"4b367b60"}[chunkId] + ".chunk.js";
};